module.exports = __webpack_public_path__ + "img/reviewlist.dce0d4b0.svg";